import { render, staticRenderFns } from "./tariff-dialog.vue?vue&type=template&id=08d486b3&"
import script from "./tariff-dialog.vue?vue&type=script&lang=js&"
export * from "./tariff-dialog.vue?vue&type=script&lang=js&"
import style0 from "./tariff-dialog.vue?vue&type=style&index=0&id=08d486b3&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports